import React from 'react';
import clsx from 'clsx';
import {useResizeWindow} from '@hooks/useResizeWindow';
import {Dropdown} from '../Dropdown';
import styles from './Navigation.module.scss';
import {screens} from './config';
import {CustomLink} from './CustomLink';

const LAPTOP_BP = 1256;

export const Navigation = () => {
    const width = useResizeWindow();
    const isLaptopDown = width < LAPTOP_BP;

    if (isLaptopDown) {
        return (
            <div className={styles.navigation}>
                <Dropdown
                    label="Каталог"
                    items={screens.map(i => (
                        <div key={i.path} className={styles.navigation__item}>
                            <CustomLink path={i.path}>{i.label}</CustomLink>
                        </div>
                    ))}
                    buttonClassName={styles.navigation__item}
                />
            </div>
        );
    }

    return (
        <div className={clsx('d-none d-bp768-flex', styles.navigation)}>
            {screens.map(i => (
                <CustomLink key={i.path} path={i.path}>{i.label}</CustomLink>
            ))}
        </div>
    );
};

